<div class="x-circle-wrapper">
  <div class="first-line"></div>
  <div class="second-line"></div>
</div>
